var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42844_26245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3V8.25969H11.1098V3H1ZM8.81512 6.73676C7.97163 7.17832 7.01628 7.40961 6.05791 7.40961C5.09953 7.40961 4.14419 7.17531 3.3007 6.73676C3.23419 6.70371 3.20093 6.62862 3.21907 6.55653L3.86605 3.98826C3.87814 3.93419 3.92047 3.89214 3.97186 3.87712C4.02326 3.85909 4.0807 3.87111 4.12302 3.90415C4.67628 4.34872 5.34744 4.58301 6.06093 4.58301C6.77442 4.58301 7.44256 4.34872 7.99884 3.90415C8.04116 3.87111 8.0986 3.85909 8.15 3.87712C8.2014 3.89514 8.2407 3.93719 8.25581 3.98826L8.90279 6.55653C8.91186 6.62862 8.8786 6.70071 8.81512 6.73676Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5521 6.51143C7.78117 6.89291 6.91954 7.09116 6.05489 7.09116C5.19024 7.09116 4.32861 6.88991 3.55768 6.51143L4.11396 4.29761C4.68233 4.6881 5.36256 4.89837 6.05489 4.89837C6.74721 4.89837 7.42745 4.6851 7.99582 4.29761L8.5521 6.51143Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1098 8.58105H1V10.0169H11.1098V8.58105Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.0865V14H11.1098V12.0865H1ZM5.57419 13.3632C5.57419 13.4503 5.50163 13.5224 5.41395 13.5224H1.64093C1.55326 13.5224 1.4807 13.4503 1.4807 13.3632V12.7264C1.4807 12.6393 1.55326 12.5672 1.64093 12.5672H5.41395C5.50163 12.5672 5.57419 12.6393 5.57419 12.7264V13.3632ZM7.25814 13.5224C6.99209 13.5224 6.77744 13.3091 6.77744 13.0448C6.77744 12.7804 6.99209 12.5672 7.25814 12.5672C7.52419 12.5672 7.73884 12.7804 7.73884 13.0448C7.73884 13.3091 7.52419 13.5224 7.25814 13.5224ZM8.70326 13.5224C8.43721 13.5224 8.22256 13.3091 8.22256 13.0448C8.22256 12.7804 8.43721 12.5672 8.70326 12.5672C8.9693 12.5672 9.18395 12.7804 9.18395 13.0448C9.18395 13.3091 8.9693 13.5224 8.70326 13.5224ZM10.1756 13.5224C9.90953 13.5224 9.69488 13.3091 9.69488 13.0448C9.69488 12.7804 9.90953 12.5672 10.1756 12.5672C10.4416 12.5672 10.6563 12.7804 10.6563 13.0448C10.6563 13.3091 10.4416 13.5224 10.1756 13.5224Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38816 11.7681H4.72467L4.98467 10.3323H7.12514L7.38816 11.7681Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70326 13.2039C8.79176 13.2039 8.8635 13.1326 8.8635 13.0447C8.8635 12.9568 8.79176 12.8855 8.70326 12.8855C8.61477 12.8855 8.54303 12.9568 8.54303 13.0447C8.54303 13.1326 8.61477 13.2039 8.70326 13.2039Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25813 13.2039C7.34663 13.2039 7.41837 13.1326 7.41837 13.0447C7.41837 12.9568 7.34663 12.8855 7.25813 12.8855C7.16964 12.8855 7.0979 12.9568 7.0979 13.0447C7.0979 13.1326 7.16964 13.2039 7.25813 13.2039Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1756 13.2039C10.264 13.2039 10.3358 13.1326 10.3358 13.0447C10.3358 12.9568 10.264 12.8855 10.1756 12.8855C10.0871 12.8855 10.0153 12.9568 10.0153 13.0447C10.0153 13.1326 10.0871 13.2039 10.1756 13.2039Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25068 12.8855H1.80115V13.2039H5.25068V12.8855Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6795 5.39099V12.486C13.6795 12.9696 13.2835 13.3631 12.7967 13.3631C12.31 13.3631 11.9139 12.9696 11.9139 12.486V10.095C11.9139 9.81562 11.7053 9.58132 11.4332 9.54227V9.22087C11.8837 9.25992 12.2344 9.6384 12.2344 10.095V12.486C12.2344 12.7924 12.4853 13.0447 12.7967 13.0447C13.1081 13.0447 13.359 12.7954 13.359 12.486V5.39099H13.6795Z",
    fill: "#6576FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.29137C14 3.36947 13.9697 3.44156 13.9153 3.49863L13.7279 3.68487C13.6976 3.71491 13.6795 3.75396 13.6795 3.79902V5.07564H13.359V3.79902C13.359 3.75696 13.3409 3.71491 13.3107 3.68487L13.1232 3.49863C13.0688 3.44457 13.0386 3.36947 13.0386 3.29137C13.0386 3.12916 13.1716 3 13.3318 3H13.7067C13.8669 3 14 3.12916 14 3.29137Z",
    fill: "#6576FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42844_26245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 11,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRis);
export default __webpack_public_path__ + "static/media/RIS.94569d59.svg";
export { ForwardRef as ReactComponent };